<template>
  <v-row class="background">
    <v-col class="py-0">
      <v-row v-if="screen.logo_base64">
        <v-col
          class="py-0  d-flex justify-center"
          offset-sm="4"
          sm="4"
        >
          <v-img
            contain
            height="80pt"
            width="100pt"
            :src="'data:image/jpg;base64,'+screen.logo_base64"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center pb-1">
          <span :style="`color: ${screen.text1.color};font-size: ${screen.text1.size}px`">
            {{ screen.text1.text }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center py-1">
          <span :style="`color: ${screen.text2.color}; font-size: ${screen.text2.size}px`">
            {{ this.screen.text2.text }}
          </span>
        </v-col>
      </v-row>
      <v-row v-if="screen.buttons.text.text">
        <v-col
          cols="12"
        >
          <v-btn
            :disabled="btnDisabled"
            width="100%"
            :style="`color: ${screen.buttons.text.color}; background-color: ${screen.buttons.background}`"
            @click="onClick()"
          >
            {{ screen.buttons.text.text }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script >
import { configuration } from "@/views/loyalty/models/justpay-configuration.model"
import { setScreenBackground } from "@/views/loyalty/shared/modules/utilities"

export default {
  name: 'ConfigurationRelayScreen',
  props: {

    screen: {
      type: Object,
      default: configuration.interface_description.first_screen
    },
  },
  data: () => ({
    btnDisabled: false,
    planogramm: null,
}),
  watch: {
    'screen.background' (newValue) {
      setScreenBackground(newValue)
    }
  },
  beforeMount () {
    console.log('text->', this.screen.text1.text)
  },
  methods: {
    onClick () {
      this.btnDisabled = true
      this.$emit('onClick')
    },
  }
}
</script>

<style scoped>

</style>
